import { useState } from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// ✅ Custom wrapper with video background
function BackgroundWrapper({ children }) {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Video background */}
      <video
        className="fixed inset-0 z-0 w-full h-full object-cover"
        src="/assets/bg1.mp4"
        autoPlay
        muted
        loop
        playsInline
      />

      {/* Optional readability overlay */}
      <div className="fixed inset-0 z-0 bg-black/50" />

      {/* Page content */}
      <div className="relative z-10">{children}</div>
    </div>
  );
}

function altFromFilename(filename) {
  return `CHAOTIK Star Citizen screenshot - ${filename
    .replace(/\.[^.]+$/, "")
    .replace(/[-_]/g, " ")}`;
}

export default function Media() {
  const imageFilenames = [
    "skulls.png",
    "fuckup.png",
    "site-b.png",
    "polaris.png",
    "mighty.jpg",
    "cruising.jpg",
    "sailing.jpg",
    "fangs.jpg",
    "laser-sitting.jpg",
    "my-ship.jpg",
    "rawr.jpg",
    "sun-over-aberdeen.jpg",
    "welcome_to.jpg",
    "briefing.png",
    "spotting.png",
    "sunset2.png",
    "wike1.png",
    "wike2.png",
    "mine1.jpeg",
    "lots.jpg",
    "rock1.jpg",
    "rock2.jpg",
    "cum.png",
    "hercumore.png",
    // Add more if needed
  ];

  const images = imageFilenames.map((file) => `/screenshots/${file}`);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://chaotik.org/" },
      { "@type": "ListItem", position: 2, name: "Media", item: "https://chaotik.org/media/Media" },
    ],
  };

  return (
    <BackgroundWrapper>
      <Layout>
        <Helmet>
          <title>CHAOTIK Star Citizen Screenshots | Org Media</title>
          <meta
            name="description"
            content="Star Citizen screenshots from CHAOTIK members &mdash; ships, sunsets, combat drops, industrial operations and moments from a 24/7 multi-role EU/US/AUS org."
          />
          <link rel="canonical" href="https://chaotik.org/media/Media" />
          <meta property="og:title" content="CHAOTIK Star Citizen Screenshots" />
          <meta
            property="og:description"
            content="Star Citizen screenshots from CHAOTIK members."
          />
          <meta property="og:url" content="https://chaotik.org/media/Media" />
          <meta name="twitter:title" content="CHAOTIK Star Citizen Screenshots" />
          <meta name="twitter:description" content="Star Citizen screenshots from CHAOTIK members." />
          <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
        </Helmet>
        <div className="flex flex-col items-center text-center mt-10">
          <h1 className="sr-only">CHAOTIK Star Citizen Screenshots</h1>
          {/* Screenshot of the Month */}
          <div className="mb-16">
            <h2 className="text-white text-3xl sm:text-4xl md:text-5xl font-bebas mb-6">
              Screenshot of the Month
            </h2>
            <img
              src="/screenshots/hercumore.png"
              alt="CHAOTIK Star Citizen screenshot of the month - briefing"
              className="rounded-xl w-full max-w-[800px] mx-auto cursor-pointer border border-red-500/40 shadow-[0_0_25px_rgba(248,113,113,0.35)]"
              onClick={() => {
                setIsOpen(true);
                setPhotoIndex(23);
              }}
            />
          </div>

          {/* Screenshot Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
            {images.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={altFromFilename(imageFilenames[index])}
                loading="lazy"
                className="rounded-lg max-w-full object-cover cursor-pointer border border-red-500/40 shadow-[0_0_20px_rgba(248,113,113,0.35)]"
                onClick={() => {
                  setIsOpen(true);
                  setPhotoIndex(index);
                }}
              />
            ))}
          </div>

          {isOpen && (
            <Lightbox
              open={isOpen}
              close={() => setIsOpen(false)}
              slides={images.map((src) => ({ src }))}
              index={photoIndex}
              on={{
                view: ({ index }) => setPhotoIndex(index),
              }}
            />
          )}
        </div>
      </Layout>
    </BackgroundWrapper>
  );
}
